import { MEASUREMENT_ESTIMATES } from "../constants";

export default function getPricingEstimate({ estimate, skipMeasurement = false }) {
  if (skipMeasurement === true) {
    return MEASUREMENT_ESTIMATES.FLAT_RATE_LOOKUP_ESTIMATE_SQFT;
  }
  return estimate;
}

